import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PortalAuthService } from 'portal-auth';
import {StartupService} from '../../core/service/startup.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'startup-errors',
  templateUrl: './startup-errors.component.html',
  styleUrls: ['./startup-errors.component.scss'],
  standalone: false
})
export class StartupErrorsComponent implements OnInit {
  @Input() errorMessage: string;

  constructor(private portalAuthService: PortalAuthService, public startupService: StartupService, private translate: TranslateService) {}

  ngOnInit(): void {}

  logout() {
    this.portalAuthService.logout();
  }
}
